import axios from "./api";

const base = "/business/dashboard";
const baseAnalytics = "/business/admin/analytics";

const Dashboard = {
  getRecentLogins() {
    return axios.get(`${base}/admin/recent-logins`);
  },
  getRecentLocations(limit = 5) {
    return axios.get(`${base}/admin/recent-locations?limit=${limit}`);
  },
  getRecentSeekers() {
    return axios.get(`${base}/admin/recent-seekers`);
  },
  getRecentApplications(locationId) {
    const endpoint = locationId
      ? `${base}/admin/recent-applications?location_id=${locationId}`
      : `${base}/admin/recent-applications`;

    return axios.get(endpoint);
  },
  getJobAnalyticsCount(type) {
    return axios.get(`${baseAnalytics}/count?type=${type}`);
  },
  getRecentSeekerApplications(page, limit) {
    let url = `${baseAnalytics}/recent-applications`;
    if (page !== undefined) url += `?page=${page}`;
    if (limit !== undefined) url += `&limit=${limit}`;
    return axios.get(url);
  },
  getRecentSeekerRegistrations(page, limit) {
    let url = `${baseAnalytics}/recent-seekers`;
    if (page !== undefined) url += `?page=${page}`;
    if (limit !== undefined) url += `&limit=${limit}`;
    return axios.get(url);
  },
  getCityCount() {
    return axios.get(`${baseAnalytics}/groupByCityCount`);
  },
};

export default Dashboard;
